import { render } from "./startup-users-list.vue?vue&type=template&id=514a4d42&ts=true"
import script from "./startup-users-list.vue?vue&type=script&lang=ts"
export * from "./startup-users-list.vue?vue&type=script&lang=ts"

import "./startup-users-list.vue?vue&type=style&index=0&id=514a4d42&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__